import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { useInvalidate } from "@/lib/queries";

export const InvitesBanner = () => {
  const invalidate = useInvalidate();
  const { data: invites = [] } = useQuery({ queryKey: ["my-invites"], queryFn: () => api.get("/invites/mine").then((r) => r.data) });
  const respond = async (i, action) => {
    try {
      await api.post(`/invites/${i.id}/${action}`);
      invalidate("my-invites", "universes");
      toast.success(action === "accept" ? `You joined ${i.universe_name}` : "Invitation declined");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  if (!invites.length) return null;
  return (
    <div className="mb-10 space-y-2" data-testid="invites-banner">
      {invites.map((i) => (
        <div key={i.id} className="flex flex-wrap items-center justify-between gap-3 rounded-md border border-[#D97706]/40 bg-[#D97706]/5 px-5 py-4" data-testid={`invite-${i.id}`}>
          <div className="flex items-center gap-3">
            <Mail className="h-4 w-4 text-[#F59E0B]" />
            <span className="text-sm text-[#E8DFD1]"><b className="font-display text-lg font-normal">{i.inviter_name || "Someone"}</b> invited you to <b className="font-display text-lg font-normal text-[#F59E0B]">{i.universe_name}</b> as {i.role}.</span>
          </div>
          <div className="flex gap-2">
            <Button size="sm" variant="ghost" onClick={() => respond(i, "decline")} data-testid={`decline-invite-${i.id}`}>Decline</Button>
            <Button size="sm" onClick={() => respond(i, "accept")} data-testid={`accept-invite-${i.id}`}>Accept</Button>
          </div>
        </div>
      ))}
    </div>
  );
};
